"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = void 0;
const versions = __importStar(require("./versions.json"));
exports.environment = {
    production: true,
    name: 'production',
    domains: {
        frontend: 'bedsforkids.org',
        api: 'api.bedsforkids.org',
        shortLink: 'b4k.io',
        cms: 'cms.bedsforkids.org',
        content: 'content.bedsforkids.org',
        search: 'search.bedsforkids.org',
    },
    urls: {
        frontend: 'https://bedsforkids.org',
        api: 'https://api.bedsforkids.org',
        shortLink: 'https://b4k.io',
        cms: 'https://cms.bedsforkids.org',
        content: 'https://content.bedsforkids.org',
        search: 'https://search.bedsforkids.org',
    },
    version: versions.web.production,
    google: {
        recaptchaKey: '6LdNCNYfAAAAAKv86N6u1VdbuLC3HRiN5LRSHCeJ',
        recaptchaV2Key: '6LdoHCYpAAAAAJ7g5gnOQ-bg55n59IQPpvdWRuYB',
        maps: {
            mapId: '7db42fd6865e2751',
            embedKey: 'AIzaSyCq2NTjAs7_pqwsto5rd7VOTwfQujZbdDQ',
        },
    },
    stripe: {
        apiKey: 'pk_live_51LNMccDxdRJr1jLuetpsdS5RySXnpsGwhHGvUTQZJCvlEm16GEnPqLNhNbk1A3pI35ng5TSOaNpl6rdz3CcM0dmC00LIYNrucg',
    },
    strapi: {
        read: '193e21cca4a28f957d4ba58f86ccbf4966a3f25b49e5547ef61c86aaba7fd35044ce9a929f71ff880787f2e61a2389ec711c1d7ee6908b54bd3427e3db047852d969c9b7b6f89bd24b7c43cfb72965419f6a594569698fdaed98ef8ad22748d88ce50c37f9441550effd5063b878136fad98a8e81b0f4c7bedca2bdea4f23517',
    },
    cookies: {
        prefix: '',
        domain: 'bedsforkids.org',
    },
    highlight: {
        projects: { web: '2' },
        urls: { backend: 'https://highlight.bedsforkids.org' },
    },
};
